<template>
  <div class="vipsearch">
    <NodeNav></NodeNav>
    <div class="find-service-wrap">
      <div class="find-service">
        <!-- <div class="back" @click="goBack">
          <div class="back-icon"></div>
          发现服务
        </div> -->
        <div class="no-service-wrap" v-if="false"></div>
        <div class="service-wrap">
          <div
            class="service-item"
            :class="{
              'service-item2': !selectList.includes(service),
              'service-item3': selectList.includes(service),
            }"
            :key="index"
            v-for="(service, index) in searchServiceList"
            @click="selectService(service)"
          >
            <!-- <div :class="{ 'item-icon': true }"></div> -->
            <div
              v-if="service.icon"
              :class="{
                'service-logo': true,
              }"
              :style="{
                'background-image': 'url(\'' + service.icon + '\')',
              }"
            ></div>
            <div
              v-else
              :class="{
                'service-logo': true,
                'service-logo-nas': service.dtype == 1 || service.dtype == 6,
                'service-logo-router': service.dtype == 2,
                'service-logo-pc': service.dtype == 3 || service.dtype == 999,
              }"
            ></div>
            <div class="item-text">
              <div class="item-name">{{ service.name }}</div>
              <div class="item-ip">
                {{ $common.ipConvert(service.ip) }}:{{ service.port }}
              </div>
            </div>
            <div
              class="select-btn"
              :class="{
                'unselect-btn': !selectList.includes(service),
              }"
            ></div>
          </div>
          <div
            class="no-service"
            v-if="!searchServiceList || searchServiceList.length <= 0"
          >
            <div class="no-icon"></div>
            <div class="no-text">暂未发现服务</div>
          </div>
        </div>
        <div class="select-count">
          <div
            class="count-wrap"
            v-if="selectList.length == 0"
            @click="selectAll"
          >
            <div class="all-btn"></div>
            <div class="count-text">
              全选
              <div class="num">
                {{ selectList.length }}/{{ allServiceCount }}
              </div>
            </div>
          </div>
          <div
            class="count-wrap"
            v-else-if="selectList.length < allServiceCount"
            @click="selectAll"
          >
            <div class="all-btn all-btn2"></div>
            <div class="count-text">
              全选
              <div class="num">
                {{ selectList.length }}/{{ allServiceCount }}
              </div>
            </div>
          </div>
          <div class="count-wrap" v-else @click="unSelectAll">
            <div class="all-btn all-btn3"></div>
            <div class="count-text">
              全选
              <div class="num">
                {{ selectList.length }}/{{ allServiceCount }}
              </div>
            </div>
          </div>
        </div>
        <div class="btns">
          <div class="btn" @click="goClick">取消</div>
          <div class="btn btn2" @click="addClick">添加</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NodeNav from "@/components/Node/NodeNav.vue";
import async from "async";
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
export default {
  components: {
    Nav,
    HomeNav,
    NodeNav,
  },
  data: function () {
    return {
      allServiceCount: 0,
      deviceList: [],
      selectList: [],
      isSelectAll: false,
      serviceList: [],
      searchServiceList: [],
    };
  },
  methods: {
    ...mapActions([
      "sendUserlog",
      "scan",
      "scanlist",
      "nodelistset",
      "checkBindList",
    ]),
    addClick: function () {
      let _that = this;
      let groupObj = {};
      let peerids = [];
      for (let index = 0; index < _that.selectList.length; index++) {
        const element = _that.selectList[index];
        if (groupObj[element.dev.peerid]) {
          groupObj[element.dev.peerid].push(element);
        } else {
          // {peerid:[service]}
          peerids.push(element.dev.peerid);
          groupObj[element.dev.peerid] = [element];
        }
      }
      async.eachSeries(
        peerids,
        function (peerid, cb) {
          let addArr = [];
          for (let index = 0; index < groupObj[peerid].length; index++) {
            const service = groupObj[peerid][index];
            addArr.push(service.mac + "|" + service.port);
          }
          _that.nodelistset([
            peerid,
            addArr,
            function (err, data) {
              cb ? cb() : null;
            },
          ]);
        },
        function () {
          _that.goClick();
        }
      );
    },
    unSelectAll: function () {
      let _that = this;
      _that.selectList = [];
      _that.isSelectAll = false;
    },
    selectAll: function () {
      let _that = this;
      _that.selectList = [];
      for (let index = 0; index < _that.deviceList.length; index++) {
        const dev = _that.deviceList[index];
        for (let j = 0; j < dev.searchServiceList.length; j++) {
          const service = dev.searchServiceList[j];
          _that.selectList.push(service);
        }
      }
      _that.isSelectAll = true;
    },
    selectService: function (service) {
      let _that = this;
      if (!_that.selectList.includes(service)) {
        _that.selectList.push(service);
      } else {
        for (let index = 0; index < _that.selectList.length; index++) {
          const element = _that.selectList[index];
          if (element == service) {
            _that.selectList.splice(index, 1);
            break;
          }
        }
      }
      if (_that.selectList.length == _that.allServiceCount) {
        _that.isSelectAll = true;
      } else {
        _that.isSelectAll = false;
      }
    },

    goClick: function () {
      let _that = this;
      _that.$router.back(-1);
      //   _that.$router.push("/home/viphome");
    },
    goBack: function () {
      this.$router.back(-1);
    },
    renderServices: function () {
      let _that = this;

      _that.allServiceCount = 0;
      let item = _that.$store.state.curDev;
      _that.scanServices(item, function (err, data) {
        console.log("scanServices", data);
        //搜索到的服务
        _that.searchServiceList = data;
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          //把设备放到服务中
          element.dev = item;
        }
        _that.allServiceCount += data.length;
        _that.$forceUpdate();
      });
    },
    scanServices: function (dev, cb) {
      let _that = this;
      _that.scan([
        dev.peerid,
        function (err, data) {
          let ready = data.ready;
          let timeoutSecond = ready ? 0 : 100;
          setTimeout(function () {
            //扫描服务
            _that.scanlist([
              dev.peerid,
              function (err, data) {
                let searchServiceList = [];
                if (data && !data.rtn && data.jd) {
                  for (let i = 0; i < data.jd.length; i++) {
                    let svs = data.jd[i].svs;
                    // 过滤离线设备
                    if (data.jd[i].status == 1) {
                      continue;
                    }
                    //有dtype
                    if (data.jd[i].dtype) {
                      //不显示没有类型的服务
                      if (svs) {
                        if (svs.length > 0) {
                          //有多个端口需要进行拆分
                          for (let j = 0; j < svs.length; j++) {
                            let item = JSON.parse(JSON.stringify(data.jd[i]));
                            item.ports = [svs[j].port];
                            item.port_name = svs[j].name ? svs[j].name : "";
                            item.rule = svs[j].rule ? svs[j].rule : 0;
                            item.icon = svs[j].icon ? svs[j].icon : 0;
                            item.button = svs[j].button ? svs[j].button : "";

                            // for test
                            // item.icon = "";

                            if (
                              !_that.isServiceListInclude(
                                dev.peerid,
                                data.jd[i].mac,
                                svs[j].port
                              )
                            ) {
                              searchServiceList.push(item);
                            }
                          }
                        }
                      } else {
                        //离线设备
                        if (data.jd[i].status == 1) {
                          //仅添加离线的能够开机的设备
                          if (
                            !_that.isServiceListIncludeIP(
                              dev.peerid,
                              data.jd[i].ip
                            )
                          ) {
                            searchServiceList.push(data.jd[i]);
                          }
                        }
                      }
                    }
                  }

                  // console.log(searchServiceList);

                  _that.rebuildList(searchServiceList, dev);

                  // console.log(searchServiceList);

                  cb ? cb(null, searchServiceList) : null;
                } else {
                  cb ? cb(null, searchServiceList) : null;
                }
              },
            ]);
          }, timeoutSecond);
        },
      ]);
    },
    isServiceListInclude: function (peerid, mac, port) {
      let _that = this;
      for (let j = 0; j < _that.serviceList.length; j++) {
        const service = _that.serviceList[j];
        if (mac == service.mac && port == service.port) {
          return true;
        }
      }
      return false;
    },
    isServiceListIncludeIP: function (peerid, ip) {
      let _that = this;
      //遍历设备
      for (let j = 0; j < _that.serviceList.length; j++) {
        const service = _that.serviceList[j];
        if (ip == service.ip) {
          return true;
        }
      }
      return false;
    },
    rebuildList: function (list, dev) {
      let _that = this;

      // console.log(dev.peerid, JSON.stringify(list));

      if (dev) {
        // console.log(dev);
      }

      // 过滤本机服务
      // for (let index = list.length - 1; index >= 0; index--) {
      //   const element = list[index];
      //   if (dev.term && dev.term.nic) {
      //     for (let j = 0; j < dev.term.nic.length; j++) {
      //       const nic = dev.term.nic[j];
      //       if (
      //         element.mac == nic.mac ||
      //         dev.peerid.indexOf(element.mac) > -1
      //       ) {
      //         // console.log(element);
      //         list.splice(index, 1);
      //       }
      //     }
      //   }
      // }

      _that.$common.rebuildServerItems(list, _that.$store.state.nasExPorts);

      for (let index = list.length - 1; index >= 0; index--) {
        const element = list[index];
        // 联想渠道隐藏nas设备
        if (element.dtype == 1 && _that.$store.state.user.isAllLenvNas) {
          list.splice(index, 1);
        } else if (element.dtype == 1 && element.port == 80) {
          // nas过滤80
          list.splice(index, 1);
        } else if (element.dtype == 2 && element.port != 80) {
          // 遍历删除路由器设备非80端口
          list.splice(index, 1);
        } else if (element.port == 631) {
          // 隐藏打印机631
          list.splice(index, 1);
        }

        // else if (
        // 	element.dtype == 1 &&
        // 	element.port != 5000 &&
        // 	element.port != 8080
        // ) {
        // 	list.splice(index, 1);
        // } else if (
        // 	element.dtype == 3 &&
        // 	element.port != 3389 &&
        // 	!element.status
        // ) {
        // 	// 遍历删除在线电脑设备非3389端口
        // 	list.splice(index, 1);
        // }
      }

      // 按ip排序
      list.sort(function (a, b) {
        return a.ip_num - b.ip_num;
      });

      // console.log(dev.peerid, JSON.stringify(list));
    },
  },
  activated() {
    let _that = this;

    // 初始化数据
    _that.allServiceCount = 0;
    _that.deviceList = [];
    _that.selectList = [];
    _that.isSelectAll = false;

    _that.serviceList = _that.$route.params.serviceList
      ? _that.$route.params.serviceList
      : [];

    _that.checkBindList([
      false,
      function (err, list) {
        _that.renderServices();
      },
    ]);
  },
};
</script>
<style lang="less" scoped>
.find-service-wrap {
  background-color: #f2f5fa;
  //   width: 960px;
  height: 426px;
  overflow: hidden;
}
.find-service {
  margin: 0 auto;
  //   width: 940px;
  height: 418px;
  box-sizing: border-box;
  border-radius: 4px;
  // background-image: url("../../assets/vip/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #ffffff;
  //   border: 1px solid #e8c29b;
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  overflow: hidden;
  .back {
    width: 200px;
    line-height: 50px;
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    .back-icon {
      display: inline-block;
      margin-top: 16px;
      margin-left: 24px;
      margin-right: 6px;
      vertical-align: top;
      width: 16px;
      height: 16px;
      background-image: url("../../assets/vip/back.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .no-service-wrap {
  }
  .service-wrap {
    margin: 0 auto;
    margin-left: 8px;
    margin-top: 8px;
    width: 923px;
    height: 295px;
    box-sizing: border-box;
    overflow-y: scroll;
    .device-service {
      .device-service-title {
        margin: 0 auto;
        margin-bottom: 6px;
        padding-left: 24px;
        width: 906px;
        height: 36px;
        line-height: 36px;
        background-image: url("../../assets/vip/deviceTitle.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border-radius: 8px 8px 0px 0px;
        color: #1f1f1f;
        box-sizing: border-box;
      }
    }

    .service-item {
      position: relative;
      margin: 6px;
      display: inline-block;
      vertical-align: top;
      width: 292px;
      height: 100px;
      background-color: #fcfdff;
      border: 1px solid #d7deec;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
      .item-icon {
        display: inline-block;
        margin-top: 29px;
        margin-left: 24px;
        margin-right: 8px;
        vertical-align: top;
        width: 42px;
        height: 42px;
        background-image: url(../../assets/remote/deviceOn.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .service-logo {
        display: inline-block;
        margin-top: 29px;
        margin-left: 24px;
        margin-right: 8px;
        vertical-align: top;
        width: 36px;
        height: 36px;
        // border-radius: 22px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% auto;
      }

      .service-logo.service-logo-nas {
        background-image: url(../../assets/home/node/nas_online.svg);
      }
      .service-logo.service-logo-router {
        background-image: url(../../assets/home/node/router_online.svg);
      }
      .service-logo.service-logo-pc {
        background-image: url(../../assets/home/node/pc_online2.svg);
      }
      .item-text {
        display: inline-block;
        margin-top: 28px;
        vertical-align: top;
        .item-name {
          width: 180px;
          line-height: 24px;
          font-size: 16px;
          font-weight: 700;
          color: #1a1a1a;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item-ip {
          margin-top: 4px;
          font-size: 12px;
          line-height: 16px;
          color: #666666;
          .item-ip-dot {
            display: inline-block;
            margin-top: 6px;
            vertical-align: top;
            width: 4px;
            height: 4px;
            background-color: #666666;
            border-radius: 2px;
          }
        }
      }
      .select-btn {
        position: absolute;
        right: 12px;
        bottom: 12px;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/vip/add2.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .unselect-btn {
        background-image: url("../../assets/vip/add.svg");
      }
    }
    .service-item2:hover {
      background-color: #fffdf8;
      border: 1px solid #f7dab9;
      box-shadow: 0px 3px 7px rgba(197, 187, 161, 0.1);
      .item-icon {
        background-image: url(../../assets/remote/deviceOnVip.png);
      }
      .item-text {
        .item-name {
          color: #865311;
        }
        .item-ip {
          color: #bc8845;
          .item-ip-dot {
            background-color: #bc8845;
          }
        }
      }
      .select-btn {
        background-image: url("../../assets/vip/addHover.svg");
      }
    }
    .service-item3 {
      background-color: #fff5e9;
      border: 1px solid #e8c29b;
      .item-icon {
        background-image: url(../../assets/remote/deviceOnVip.png);
      }
    }
    .no-service {
      margin-top: 90px;
      margin-bottom: 40px;
      text-align: center;
      .no-icon {
        margin: 0 auto;
        width: 90px;
        height: 85px;
        background-image: url("../../assets/vip/noService.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .no-text {
        margin-top: 29px;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #1f1f1f;
      }
      .no-text2 {
        margin-top: 5px;
        font-size: 13px;
        line-height: 18px;
        color: #666666;
      }
    }
  }
  .select-count {
    position: relative;
    margin-top: 15px;
    margin-left: 16px;
    line-height: 40px;
    height: 40px;
    width: 200px;
    font-size: 12px;
    color: #666666;
    cursor: pointer;
    .count-wrap {
      position: absolute;
      height: 40px;
      width: 200px;

      .all-btn {
        display: inline-block;
        margin-top: 9px;
        margin-right: 8px;
        vertical-align: top;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/vip/addAll.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .all-btn2 {
        background-image: url("../../assets/vip/addAll2.svg");
      }
      .all-btn3 {
        background-image: url("../../assets/vip/add2.svg");
      }
      .count-text {
        display: inline-block;
        vertical-align: top;
        .num {
          display: inline-block;
          margin-left: 4px;
          margin-right: 4px;
          vertical-align: top;
          font-size: 16px;
          color: #1e3251;
        }
      }
    }
  }
  .btns {
    margin-top: -40px;
    text-align: center;
    .btn {
      display: inline-block;
      vertical-align: top;
      width: 156px;
      height: 42px;
      line-height: 42px;
      //   font-weight: 700;
      font-size: 16px;
      color: #4a4a4a;
      background: linear-gradient(180deg, #dcdcdc 9.38%, #c4c3c7 100%);
      box-shadow: 0px 3px 7px rgba(43, 48, 57, 0.2);
      border-radius: 200px;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
    }
    .btn2 {
      margin-left: 24px;
      background: linear-gradient(
        189deg,
        #6c69fe 0%,
        #4c49ec 35.94%,
        #29439d 99.24%
      );
      color: #ffffff;
    }
  }
}
</style>